import React, { useEffect } from 'react';
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth, API } from './context/AuthContext';
import { Toaster } from 'sonner';
import axios from 'axios';

import Navigation from './components/Navigation';
import Watermark from './components/Watermark';
import Home from './pages/Home';
import About from './pages/About';
import Author from './pages/Author';
import Excerpts from './pages/Excerpts';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Purchase from './pages/Purchase';
import Dashboard from './pages/Dashboard';
import Reader from './pages/Reader';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancelled from './pages/PaymentCancelled';
import AdminDashboard from './pages/AdminDashboard';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="font-body text-xl text-muted-charcoal">Besig om te laai...</p>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" />;
};

function AppContent() {
  const location = useLocation();
  const showWatermark = location.pathname !== '/reader';

  // Track page visits
  useEffect(() => {
    const trackVisit = async () => {
      try {
        await axios.post(`${API}/track/visit`);
      } catch (error) {
        // Silently fail - don't disrupt user experience
        console.log('Visit tracking failed');
      }
    };
    trackVisit();
  }, [location.pathname]);

  return (
    <>
      {showWatermark && <Watermark />}
      <Navigation />
      <Toaster position="top-right" theme="light" offset="80px" />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/author" element={<Author />} />
        <Route path="/excerpts" element={<Excerpts />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/purchase" element={<Purchase />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-cancelled" element={<PaymentCancelled />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/reader"
          element={
            <ProtectedRoute>
              <Reader />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
